import { jsx as _jsx } from "react/jsx-runtime";
import { Code } from '../../markdown';
export function ExampleView({ value }) {
    const content = JSON.stringify(value, null, '  ');
    return _jsx(Code, { content: content, children: content });
}
